





















































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ActivityChart from "@/components/Main/Charts/ActivityChart";
import { ActivitySchema } from "@/models/activity_schema";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { StoreModule } from "@/store/types";
import { CustomerGetters } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import {CustomerSchema} from "@/models/customer_schema";
import { RepGetters } from "@/store/modules/rep/types";
import { Range } from "@/models/graph/date_range";
import { chartData } from "@/models/graph/chart_data";
import { EventBus } from "@/events/index";
import { Roles } from "@/models/roles";
import { UserGetters } from "@/store/modules/user/types";
import simplebar from "simplebar-vue";
import { User } from "@/models/user_schema";

@Component({
  components: {
    ActivityChart,
    Datepicker,
    simplebar,
  },
})
export default class ActivityHistory extends Vue {
  @Prop() notesData!: ActivitySchema[]; // passed from Main.vue
  protected dateRange = "";
  protected moment = moment;
  protected sort = { category: "contacted_at", order: "asc" };
  protected currentSort = { category: "contacted_at", order: "asc" };
  protected filter = "";
  protected Range = Range;
  protected graphData: number[] = [];
  protected labels: moment.Moment[] = [];
  protected selectedCustomerId: string | null = null;
  protected selectedRepId: string | null = null;
  protected gradient!: CanvasGradient;
  protected showHistoryDiv = false;
  protected Roles = Roles;
  protected customerList: CustomerSchema[] = [];
  protected region = "";

  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;
  @(namespace(StoreModule.Rep).Getter(RepGetters.GetSelected))
  selected;
  @(namespace(StoreModule.Rep).Getter(RepGetters.GetAllReps)) reps;

/**     
 * Route/navigation change watcher
 * Detects changes that require note/activity & graph updates
  */
  @Watch("$route")
  public onRouteChange(to, from): void {
    /** Close activity history screen if switching between customer & rep views */
    if (from.name) {
      if (
        ((to.name as string).includes("customer") &&
          !(from.name as string).includes("customer")) ||
        ((to.name as string).includes("reps") &&
          !(from.name as string).includes("reps"))
      ) {
        this.close();
      }
    }
  
     // update data based on id parameter in URL/path
     // id parameter is only present in sinle entity view (single rep or single customer/customer)
    if (this.$route.params.id) {
      const id = this.$route.params.id.trim();
      // rules for customer view
      if ((this.$route.name as string).includes("customer")) {
        this.selectedCustomerId = id;
        this.selectedRepId = null;
      // rules for rep view
      } else {
        this.selectedRepId = id;
        this.selectedCustomerId = null;
      }
      // follow by updating region using new entity & fetching notes from API (through event emitted to parent)
      this.region = this.getSalesRegion();
      this.updateNotes();

    // update data if there is a region specified in the navigated-to url, and it does NOT match the current region property (we have not updated the region yet at this new path)
    } else if (to.query.region && this.region !== to.query.region) {
      // set ids to the first entity in the arrary. since there is no id parameter in the url,
      // we are in a list view, and since we are changing regions, the prior selected entity
      // will be filtered out
      this.selectedCustomerId = this.filteredCustomers[0]._id;
      this.selectedRepId = this.filteredReps[0]._id;
      // folow by updating region & notes data
      this.updateNotes();
      this.region = this.getSalesRegion();

    // logic for one specific case: navigating from single rep view to rep list view
    // if navigating to root '/' & it has region in the query, but it DOES match this.region (this is the filtered rep list view), or navigating directly to the unfiltered rep list ("/")
    } else if (to.query.region || to.path === "/") {
      if ((this.$route.name as string).includes("rep")) {
        // reset the selected customer. the user cannot cycle through customer/customers on 
        //the rep list views, we want to see all customer data as we cycle through reps in the dropdown   
        this.selectedCustomerId = null;
      }
    }
  }

  mounted() {
    EventBus.$on(
      "submittedActivity",
      (note: ActivitySchema, isNew: boolean) => {
        this.updateNotes();
      }
    );
  }

      beforeDestroy() {
    EventBus.$off('submittedActivity');
  }
/**
 * This logic will have to be adjusted if the graph view is ever called outside
 * the single rep/customer view (non-list view)
 */
  public created() {
    const id = this.$route.params.id.trim();
    if ((this.$route.name as string).includes("customer")) {
      this.selectedCustomerId = id;
    } else {
      this.selectedRepId = id;
    }
    this.region = this.getSalesRegion();
  }

  public get notes(): ActivitySchema[] {
    return this.notesData;
  }

  public getSalesRegion(): string {
    let region;
    if (this.selectedRepId) {
      const rep: User = this.reps.filter((rep) => {
        if (rep._id === this.selectedRepId) {
          return rep;
        }
      });
      region = rep[0].sales_region;
    } else if (this.selectedCustomerId) {
      const customer: CustomerSchema  = this.customers.filter((customer) => {
        if (customer._id === this.selectedCustomerId) {
          return customer;
        }
      });
      region = customer[0].sales_region;
    }
    return region;
  }

  public close(): void {
    EventBus.$emit("showActivityHistory", false, null, null);
  }

  public mountedGraph(): void {
    this.getGradient();
  }

  public updateNotes(): void {
    if ((this.$route.name as string).includes("customer")) {
      this.$emit("fetchCustomerActivityNotes", this.selectedCustomerId, true);
    } else {
      this.$emit("fetchRepActivityNotes", this.selectedRepId, true);
    }
  }

  public getGradient(): void {
    // create canvas gradient & save as instance variable to apply to graph
    const canvas = document.getElementById("line-chart") as HTMLCanvasElement;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      if (ctx) {
        this.gradient = ctx.createLinearGradient(0, 0, 0, 600);
        this.gradient.addColorStop(0, "rgba(0,137,255,0.5)");
        this.gradient.addColorStop(0.5, "rgba(0,137,255,0.3)");
        this.gradient.addColorStop(1, "rgba(255,255,255,0)");
      }
    }
  }

  public populateDefaultGraphData(): void {
    this.labels = this.getLabels();
    this.graphData = this.getGraphData(this.notes);
  }

  public getEarliestNote(): moment.Moment {
    const moments = this.notes.map((note) => moment(note.contacted_at));
    return moment.min(moments);
  }

  public selectSort(sortCategory: string) {
    if (this.currentSort.category !== sortCategory) {
      // default is asc, so if we're sorting a new category, automatically set to desc
      this.sort.category = sortCategory;
      this.sort.order = "desc";
    } else {
      if (this.sort.order === "asc" || !this.sort.order) {
        this.sort.order = "desc";
      } else {
        this.sort.order = "asc";
      }
    }
    this.currentSort = this.sort;
  }

  get datacollection(): chartData {
    const obj = {
      labels: [""],
      datasets: [
        {
          backgroundColor: {} as CanvasGradient,
          borderColor: "",
          data: [0],
        },
      ],
    } as chartData;
    let formatting;
    if (this.dateRange) {
      formatting = "MM/DD";
    } else {
      formatting = "MM/YYYY";
    }
    obj.labels = this.labels.map((label) => {
      return label.format(formatting);
    });
    obj.datasets[0].backgroundColor = this.gradient;
    obj.datasets[0].borderColor = "rgba(0,137,255,0.5)";
    obj.datasets[0].data = this.graphData;
    return obj;
  }

  get filteredCustomers(): CustomerSchema[] {
    const salesRegion = this.selected.sales_region
      ? this.selected.sales_region
      : this.$route.query.region;
    if (salesRegion) {
      this.customerList = this.customers.filter((customer) => {
        return customer.sales_region === salesRegion;
      });
    } else {
      this.customerList = this.customers;
    }
    return this.customerList;
  }

  get filteredReps(): User[] {
    const salesRegion = this.selected.sales_region
      ? this.selected.sales_region
      : this.$route.query.region;
    let repList: User[] = [];
    if (salesRegion) {
      repList = this.reps.filter((rep) => {
        return rep.rep_info.sales_region === salesRegion;
      });
    } else {
      repList = this.reps;
    }
    return repList;
  }

  get filteredNotes(): ActivitySchema[] {
    let notesArray = [...this.notes];
    if (!this.dateRange) {
      this.populateDefaultGraphData();
    } else {
      this.labels = this.getLabels();
      notesArray = this.filterByDateRange(notesArray);
      this.graphData = this.getGraphData(notesArray);
    }
    if (this.selectedCustomerId) {
      notesArray = notesArray.filter((note) => {
        return note.customer === this.selectedCustomerId;
      });
      this.graphData = this.getGraphData(notesArray);
    }
    if (this.sort.category || this.sort.order) {
      if (this.sort.category === "customer" && this.sort.order === "desc") {
        notesArray.sort((a, b) =>
          this.getCustomerName(a[this.sort.category]) >
          this.getCustomerName(b[this.sort.category])
            ? 1
            : -1
        );
      } else if (
        this.sort.category === "customer" &&
        this.sort.order === "asc"
      ) {
        notesArray.sort((a, b) =>
          this.getCustomerName(a[this.sort.category]) <
          this.getCustomerName(b[this.sort.category])
            ? 1
            : -1
        );
      } else if (this.sort.order === "desc") {
        notesArray.sort((a, b) =>
          a[this.sort.category] > b[this.sort.category] ? 1 : -1
        );
      } else {
        notesArray.sort((a, b) =>
          a[this.sort.category] < b[this.sort.category] ? 1 : -1
        );
      }
    }
    return notesArray;
  }

  public filterByDateRange(notes: ActivitySchema[]): ActivitySchema[] {
    let filtered: ActivitySchema[] = [];
    if (this.labels.length === 1) {
      filtered = notes.filter((note) => {
        return (
          moment(note.contacted_at).format("MM/DD/YY") ===
          this.labels[0].format("MM/DD/YY")
        );
      });
    } else {
      const to = this.labels[this.labels.length - 1];
      const from = this.labels[0];
      filtered = notes.filter((note) => {
        return (
          from <= moment(note.contacted_at) && moment(note.contacted_at) <= to
        );
      });
    }
    return filtered;
  }

  /**
   * Compiling graph data
   * x-axis = label[index], y-axis = number (auto-generated), plotted point = data[index]
   * label.length === data.length. Pass in 0 if there is no corresponding data
   */
  public getGraphData(notes: ActivitySchema[]): number[] {
    const data: number[] = [];
    let formatting;
    if (this.dateRange) {
      formatting = "MM/DD";
    } else {
      formatting = "MM/YYYY";
    }
    this.labels.forEach((label, index) => {
      let count = 0;
      notes.forEach((note) => {
        if (
          label.format(formatting) ===
          moment(note.contacted_at).format(formatting)
        ) {
          count++;
        }
      });
      data[index] = count;
    });
    return data;
  }

  public getLabels(): moment.Moment[] {
    let labels: moment.Moment[] = [];
    switch (this.dateRange) {
      case Range.Today:
        labels = [moment()];
        break;
      case Range.Yesterday:
        labels = [moment().subtract(1, "days")];
        break;
      case Range.LastWeek: {
        const week = moment().startOf("week");
        const endDate = week.subtract(1, "week");
        labels = this.createDateRangeLabels(endDate, 7);
        break;
      }
      case Range.LastMonth: {
        const month = moment().endOf("month");
        const endDate = month.subtract(1, "month");
        const days = endDate.daysInMonth();
        labels = this.createDateRangeLabels(endDate, days);
        break;
      }
      case Range.Last7Days: {
        const endDate = moment();
        labels = this.createDateRangeLabels(endDate, 7);
        break;
      }
      case Range.Last30Days: {
        const endDate = moment();
        labels = this.createDateRangeLabels(endDate, 30);
        break;
      }
      default: {
        const dateStart = this.getEarliestNote(); // date of oldest note
        const dateEnd = moment(); // today
        const interim = dateStart.clone();
        const timeValues: string[] = [];
        while (
          dateEnd > interim ||
          interim.format("M") === dateEnd.format("M")
        ) {
          // array of months between start & end dates
          timeValues.push(interim.format("MM/DD/YYYY"));
          interim.add(1, "month");
        }
        labels = timeValues.map((value) => {
          return moment(value);
        });
      }
    }
    return labels;
  }

  /**
   * Keep labels as type moment.Moment (by not applying format() method) so they are easier to
   * compare with the dates on the activity notes
   */
  public createDateRangeLabels(
    endDate: moment.Moment,
    days: number
    // format = "MM/DD"
  ): moment.Moment[] {
    const labels: moment.Moment[] = [];
    for (let i = days - 1; i > -1; i--) {
      // moment methods mutate original date, so we need to call .clone() to make a copy
      const newDate = endDate.clone();
      labels.push(newDate.subtract(i, "days"));
    }
    return labels;
  }

  public getCustomerName(id: string): string {
    let name;
    for (let i = 0; this.customers.length; i++) {
      if (this.customers[i]._id === id) {
        name = this.customers[i].customer_name;
        break;
      }
    }
    return name;
  }
}
